// extracted by mini-css-extract-plugin
export default {"info":"NaTZA","delivery":"k74FZ","courier":"L_dH8"};